import {
    Button,
    Heading,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Stack,
    Text,
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useState } from "react";

interface IConfirmDialog {
    isOpen: boolean;
    title: string;
    message?: string | undefined;
    primaryButtonText: string | undefined;
    secondaryButtonText?: string | undefined;
    primaryAction: () => void | Promise<void>;
    secondaryAction: () => void | Promise<void>;
    onClose: () => void;
    size?: "sm" | "md" | "lg" | "xl" | "full";
    closeOnOverlayClick?: boolean;
}

function ConfirmationDialog({
    title,
    message,
    primaryButtonText,
    secondaryButtonText,
    primaryAction,
    secondaryAction,
    onClose,
    isOpen,
    size = "sm",
    closeOnOverlayClick = false,
}: IConfirmDialog) {
    const [isAwaitingSecondaryAction, setIsAwaitingSecondaryAction] = useState(false);
    const [isAwaitingPrimaryAction, setIsAwaitingPrimaryAction] = useState(false);

    const onClickSecondaryAction = async () => {
        setIsAwaitingSecondaryAction(true);
        await secondaryAction();
        setIsAwaitingSecondaryAction(false);
    };
    const onClickPrimaryAction = async () => {
        setIsAwaitingPrimaryAction(true);
        await primaryAction();
        setIsAwaitingPrimaryAction(false);
    };

    return (
        <Modal
            onClose={onClose}
            isOpen={isOpen}
            size={size}
            closeOnOverlayClick={closeOnOverlayClick}
        >
            <ModalHeader p={ThemeSpaceVariable.Medium}>
                <Heading as="h3">{title}</Heading>
            </ModalHeader>
            <ModalBody px={ThemeSpaceVariable.Medium} pb={ThemeSpaceVariable.Medium}>
                <Text fontSize={ThemeFontSizeVariable.Medium}>{message}</Text>
            </ModalBody>
            <ModalFooter
                pt={ThemeSpaceVariable.Medium}
                px={ThemeSpaceVariable.Medium}
                pb={ThemeSpaceVariable.Medium}
                display="flex"
                justifyContent="flex-end"
            >
                <Stack direction="row" spacing={ThemeSpaceVariable.Medium}>
                    <Button
                        size="xl"
                        variant="ghost"
                        onClick={() => void onClickSecondaryAction()}
                        isLoading={isAwaitingSecondaryAction}
                    >
                        {secondaryButtonText}
                    </Button>
                    <Button
                        size="xl"
                        variant="primary"
                        onClick={() => void onClickPrimaryAction()}
                        isLoading={isAwaitingPrimaryAction}
                    >
                        {primaryButtonText}
                    </Button>
                </Stack>
            </ModalFooter>
        </Modal>
    );
}

export default ConfirmationDialog;
